import { Box } from "@mui/material";
import { useState } from "react";

import approvedPPImg from "images/pp_page/approvedCCTL.png";
import archivedPPImg from "images/pp_page/archivedPP.png";
import developmentProcessImg from "images/pp_page/developmentProcess.png";

import ApprovedPPModal from "./ApprovedPPModal";
import ArchivedPPModal from "./ArchivedPPModal";
import PpHeaderCard from "./PpHeaderCard";
import PPProcessModal from "./PPProcessModal";

export default function PpModals() {
  const [showProcessModal, setShowProcessModal] = useState(false);
  const [showApprovedPPModal, setShowApprovedPPModal] = useState(false);
  const [showArchivedPPModal, setShowArchivedPPModal] = useState(false);

  const toggleProcessModal = () => setShowProcessModal(!showProcessModal);
  const toggleApprovedModal = () =>
    setShowApprovedPPModal(!showApprovedPPModal);
  const toggleArchivedModal = () =>
    setShowArchivedPPModal(!showArchivedPPModal);

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      paddingY={3}
      flexWrap="wrap"
    >
      <PpHeaderCard
        label={"Development Process"}
        icon={developmentProcessImg}
        buttonText={"Learn More"}
        onClick={toggleProcessModal}
        additionalContent={
          <PPProcessModal
            show={showProcessModal}
            handleCloseModal={toggleProcessModal}
          />
        }
      />

      <PpHeaderCard
        label={"Approved Protection Profiles"}
        icon={approvedPPImg}
        buttonText={"Learn More"}
        onClick={toggleApprovedModal}
        additionalContent={
          <ApprovedPPModal
            show={showApprovedPPModal}
            setShowApprovedPPModal={setShowApprovedPPModal}
          />
        }
      />

      <PpHeaderCard
        label={"Archived Protection Profiles"}
        icon={archivedPPImg}
        buttonText={"Learn More"}
        onClick={toggleArchivedModal}
        additionalContent={
          <ArchivedPPModal
            show={showArchivedPPModal}
            setShowArchivedPPModal={setShowArchivedPPModal}
          />
        }
      />
    </Box>
  );
}
